<!--Maakt gebruik van: https://bootstrap-vue.org/vue3-->
<template>
    <!-- Contact template -->
    <div style="border-bottom: 1px dotted #ccc; margin-bottom: 50px; padding-bottom: 30px;">
        <div class="row">
            <div class="col-md-6">
                <h2>2. Information</h2>
            </div>
            <div class="col-md-6 text-right" v-if="(Order.Guid == null || Order.Guid.length == 0) && showLogin == false">
                Already have an account? <a href="javascript:void(0);" v-on:click="showLogin = true">Log in</a>
            </div>
            <div class="col-md-6  text-right" v-if="(Order.Guid != null && Order.Guid.length > 0) || showLogin == true">
                <a href="javascript:void(0);" v-on:click="Edit()">Edit</a>
            </div>
        </div>
        <div v-show="showLogin == false">
            <div v-show="Order.Guid == null || Order.Guid.length == 0">
                <b-card>
                    <b-form @submit="SubmitContactForm" id="contactform">
                        <h3>Contact information</h3>
                        <!-- Email -->
                        <div class="wrapper-floating-label" :class="Order != null && Order.Email != null && Order.Email != '' ? 'movelabelonload' : ''">
                            <label for="OrderEmail">{{getInterfaceText('form_emailaddress')}}</label>
                            <b-form-input style="height:auto;" v-model="Order.Email" aria-describedby="emailRequired" id="OrderEmail" type="email" required></b-form-input>
                        </div>
                        <h4>Billing address</h4>
                        <!--Polen-->
                        <div v-if="Cart.CountryId==17">
                            <div class="form-group" style="float:left;margin-right:20px;">
                                <b-form-radio value="individual" v-model="Order.ClientType" v-on:click="Order.VATName='';Order.VATNum='';" id="clienttype_individual" style="width:20px;" required />
                                <label for="clienttype_individual">{{getInterfaceText('shop_client_type_individual')}}</label>
                            </div>
                            <div class="form-group">
                                <b-form-radio value="company" v-model="Order.ClientType" v-on:click="Order.VATName= '';Order.VATNum='';" id="clienttype_company" style="width:20px;" required />
                                <label for="clienttype_company">{{getInterfaceText('shop_client_type_company')}}</label>
                            </div>
                            <div v-show="Order.ClientType == 'company'">
                                <div class="form-group form-group-combined clearfix">
                                    <div class="wrapper-floating-label" :class="Order.VATName != null && Order.VATName != '' ? 'movelabelonload' : ''">
                                        <label for="OrderVATName">{{getInterfaceText('form_vat_name')}}</label>
                                        <b-form-input style="height:auto;" class="text-box" id="OrderVATName" type="text" v-model="Order.VATName" :required="Order.ClientType == 'company'"></b-form-input>
                                    </div>
                                </div>
                                <div class="form-group form-group-combined clearfix">
                                    <div class="wrapper-floating-label" :class="Order.VATNum != null && Order.VATNum != '' ? 'movelabelonload' : ''">
                                        <label for="OrderVATNum">{{getInterfaceText('form_vat_number_company')}}</label>
                                        <b-form-input style="height:auto;" class="text-box" id="OrderVATNum" type="text" v-model="Order.VATNum" :required="Order.ClientType == 'company'"></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <p id="clientTypeRequired" class="form-validation-message" style="position:relative" v-show="(Order.ClientType == null || Order.ClientType == '')">{{getInterfaceText('form_client_type_required')}}</p>
                        </div>
                        <!--Italy-->
                        <div v-if="Cart.CountryId==15">
                            <div class="form-group" style="float:left;margin-right:20px;">
                                <b-form-radio value="individual" v-model="Order.ClientType" v-on:click="Order.VATName= '';Order.VATNum='';Order.VATExtra='';" id="clienttype_individual" style="width:20px;" required />
                                <label for="clienttype_individual">
                                    {{getInterfaceText('shop_client_type_individual')}}
                                </label>
                            </div>
                            <div class="form-group">
                                <b-form-radio value="company" v-model="Order.ClientType" v-on:click="Order.VATName= '';Order.VATNum='';Order.VATExtra='';" id="clienttype_company" style="width:20px;" required />
                                <label for="clienttype_company">{{getInterfaceText('shop_client_type_company')}}</label>
                            </div>
                            <div v-show="Order.ClientType == 'company'">
                                <div class="form-group form-group-combined clearfix">
                                    <div class="wrapper-floativ-label" :class="Order.VATName != null && Order.VATName != '' ? 'movelabelonload' : ''">
                                        <label for="OrderVATName">{{getInterfaceText('form_vat_name')}}</label>
                                        <b-form-input style="height:auto;" class="text-box" id="OrderVATName" type="text" v-model="Order.VATName" :required="Order.ClientType == 'company'"></b-form-input>
                                    </div>
                                </div>
                                <div class="form-group form-group-combined clearfix">
                                    <div class="wrapper-floativ-label" :class="Order.VATNum != null && Order.VATNum != '' ? 'movelabelonload' : ''">
                                        <label for="OrderVATNum">{{getInterfaceText('form_vat_number_company')}}</label>
                                        <b-form-input style="height:auto;" class="text-box" id="OrderVATNum" type="text" v-model="Order.VATNum" :required="Order.ClientType == 'company'"></b-form-input>
                                    </div>
                                </div>
                                <div class="form-group form-group-combined clearfix">
                                    <div class="wrapper-floativ-label" :class="Order.VATExtra != null && Order.VATExtra != '' ? 'movelabelonload' : ''">
                                        <label for="OrderVATExtra">{{getInterfaceText('form_vat_extra')}}</label>
                                        <b-form-input style="height:auto;" class="text-box" id="OrderVATExtra" type="text" v-model="Order.VATExtra" :required="Order.ClientType == 'company'"></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div v-show="Order.ClientType == 'individual'">
                                <div class="form-group form-group-combined clearfix">
                                    <div class="wrapper-floativ-label" :class="Order.VATNum != null && Order.VATNum != '' ? 'movelabelonload' : ''">
                                        <label for="OrderVATNum">{{getInterfaceText('form_vat_number')}}</label>
                                        <b-form-input style="height:auto;" class="text-box" id="OrderVATNum" type="text" v-model="Order.VATNum" :required="Order.ClientType == 'individual'"></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <p id="clientTypeRequired" class="form-validation-message" style="position:relative" v-show="errorContactInfo.length > 0 && (Order.ClientType == null || Order.ClientType == '')">{{getInterfaceText('form_client_type_required')}}</p>
                        </div>
                        <!-- first name / last name -->
                        <div class="form-group form-group-combined clearfix">
                            <div class="wrapper-floating-label first-child" :class="Order != null && Order.Firstname != null && Order.Firstname != '' ? 'movelabelonload' : ''">
                                <label for="OrderFirstname">{{getInterfaceText('form_firstname')}}</label>
                                <b-form-input style="height:auto;" aria-describedby="firstNameRequired" class="" id="OrderFirstname" type="text" v-model="Order.Firstname" required></b-form-input>
                            </div>
                            <div class="wrapper-floating-label" :class="Order.Lastname != null && Order.Lastname != '' ? 'movelabelonload' : ''">
                                <label for="OrderLastname">{{getInterfaceText('form_lastname')}}</label>
                                <b-form-input style="height:auto;" aria-describedby="lastNameRequired" id="OrderLastname" type="text" v-model="Order.Lastname" required></b-form-input>
                            </div>
                        </div>
                        <LoqateAddressSearch v-show="validateAddressAtLoqate"></LoqateAddressSearch>
                        <!-- Street -->
                        <div class="form-group clearfix">
                            <div class="wrapper-floating-label" :class="Order.Street != null && Order.Street != '' ? 'movelabelonload' : ''">
                                <label for="Order_OrderStreet">{{getInterfaceText('form_street')}}</label>
                                <b-form-input style="height:auto;" aria-describedby="gearShipOnlyDescription streetRequired" id="Order_OrderStreet" type="text" v-model="Order.Street" :onblur="checkHouseNumber()" required></b-form-input>
                            </div>
                        </div>
                        <!-- Street 2 / Colonia (Mexico) -->
                        <div class="form-group clearfix" v-if="Cart.CountryId == 10 || Cart.CountryId == 14 || Cart.CountryId == 43">
                            <div class="wrapper-floating-label" :class="Order.Address2 != null && Order.Address2 != '' ? 'movelabelonload' : ''">
                                <label v-if="Cart.CountryId == 43" for="Order_Address2">{{getInterfaceText('form_colonia', 'Colonia')}} *</label>
                                <label v-else for="Order_Address2">{{getInterfaceText('form_address2')}}</label>
                                <b-form-input style="height:auto;" class="text-box single-line" id="Order_Address2" v-model="Order.Address2" type="text" :required="Cart.CountryId == 43"></b-form-input>
                            </div>
                        </div>
                        <div v-show="validateAddress() == false" style="color:red;font-size: smaller;padding-left: 14px;">
                            {{getInterfaceText('form_invalid_address')}}
                        </div>
                        <div class="form-group form-group-combined form-group-combined-first-smaller clearfix">
                            <!-- Zipcode is not required for ireland -->
                            <div class="wrapper-floating-label first-child" :class="Order.Postalcode != null && Order.Postalcode != '' ? 'movelabelonload' : ''">
                                <label for="Order_OrderPostalcode">{{getInterfaceText('form_zipcode')}}</label>
                                <b-form-input style="height:auto;" aria-describedby="postalCodeRequired ErrorContactInfo" class="text-box single-line" id="Order_OrderPostalcode" v-model="Order.Postalcode" type="text" :required="Cart.CountryId != 48"></b-form-input>
                            </div>
                            <!-- City -->
                            <div class="wrapper-floating-label" :class="Order.City != null && Order.City != '' ? 'movelabelonload' : ''">
                                <label for="Order_OrderCity">{{getInterfaceText('form_city')}}</label>
                                <b-form-input style="height:auto;" aria-describedby="cityRequired ErrorContactInfo" id="Order_OrderCity" type="text" v-model="Order.City" required></b-form-input>
                            </div>
                        </div>
                        <!-- usa -->
                        <div class="form-group form-group-combined clearfix" v-if="Cart.CountryId == 1">
                            <div class="form-group">
                                <label for="Order_State" class="sr-only">{{getInterfaceText('shop_selectstate')}}")</label>
                                <select aria-describedby="stateRequired" id="Order_State" class="form-control form-control-floating-label-style" v-model="Order.State" required>
                                    <option value="">{{getInterfaceText('shop_selectstate')}}</option>
                                    <option value="AL">Alabama</option>
                                    <option :disabled="Cart.ContainsOnlyGear == true" value="AK">Alaska</option>
                                    <option value="AZ">Arizona</option>
                                    <option value="AR">Arkansas</option>
                                    <option value="CA">California</option>
                                    <option value="CO">Colorado</option>
                                    <option value="CT">Connecticut</option>
                                    <option value="DE">Delaware</option>
                                    <option value="DC">District of Columbia</option>
                                    <option value="FL">Florida</option>
                                    <option value="GA">Georgia</option>
                                    <option :disabled="Cart.ContainsOnlyGear == true" value="HI">Hawaii</option>
                                    <option value="ID">Idaho</option>
                                    <option value="IL">Illinois</option>
                                    <option value="IN">Indiana</option>
                                    <option value="IA">Iowa</option>
                                    <option value="KS">Kansas</option>
                                    <option value="KY">Kentucky</option>
                                    <option value="LA">Louisiana</option>
                                    <option value="ME">Maine</option>
                                    <option value="MD">Maryland</option>
                                    <option value="MA">Massachusetts</option>
                                    <option value="MI">Michigan</option>
                                    <option value="MN">Minnesota</option>
                                    <option value="MS">Mississippi</option>
                                    <option value="MO">Missouri</option>
                                    <option value="MT">Montana</option>
                                    <option value="NE">Nebraska</option>
                                    <option value="NV">Nevada</option>
                                    <option value="NH">New Hampshire</option>
                                    <option value="NJ">New Jersey</option>
                                    <option value="NM">New Mexico</option>
                                    <option value="NY">New York</option>
                                    <option value="NC">North Carolina</option>
                                    <option value="ND">North Dakota</option>
                                    <option value="OH">Ohio</option>
                                    <option value="OK">Oklahoma</option>
                                    <option value="OR">Oregon</option>
                                    <option value="PA">Pennsylvania</option>
                                    <option :disabled="Cart.ContainsOnlyGear == true" value="PR">Puerto Rico</option>
                                    <option value="RI">Rhode Island</option>
                                    <option value="SC">South Carolina</option>
                                    <option value="SD">South Dakota</option>
                                    <option value="TN">Tennessee</option>
                                    <option value="TX">Texas</option>
                                    <option value="UT">Utah</option>
                                    <option value="VT">Vermont</option>
                                    <option value="VA">Virginia</option>
                                    <option value="WA">Washington</option>
                                    <option value="WV">West Virginia</option>
                                    <option value="WI">Wisconsin</option>
                                    <option value="WY">Wyoming</option>
                                </select>
                            </div>
                        </div>
                        <!--Canada-->
                        <div class="form-group form-group-combined clearfix" v-if="Cart.CountryId==10">
                            <div class="form-group">
                                <label for="Order_State" class="sr-only">{{getInterfaceText('shop_selectstate')}}</label>
                                <select aria-describedby="stateRequired" id="Order_State" class="form-control form-control-floating-label-style" v-model="Order.State" required>
                                    <option value="">shop_selectstate</option>
                                    <option value="AB">Alberta</option>
                                    <option value="BC">British Columbia</option>
                                    <option value="MB">Manitoba</option>
                                    <option value="NB">New Brunswick</option>
                                    <option value="NL">Newfoundland and Labrador</option>
                                    <option value="NS">Nova Scotia</option>
                                    <option value="NT">Northwest Territories</option>
                                    <option value="NU">Nunavut</option>
                                    <option value="ON">Ontario</option>
                                    <option value="PE">Prince Edward Island</option>
                                    <option value="QC">Quebec</option>
                                    <option value="SK">Saskatchewan</option>
                                    <option value="YT">Yukon</option>
                                </select>
                            </div>
                        </div>
                        <!-- Japan -->
                        <div class="form-group form-group-combined clearfix" v-if="Cart.CountryId == 7">
                            <div class="form-group">
                                <label for="Order_State" class="sr-only">{{getInterfaceText('shop_selectstate')}}</label>
                                <select aria-describedby="stateRequired" id="Order_State" class="form-control form-control-floating-label-style" v-model="Order.State" required>
                                    <option value="">{{getInterfaceText('shop_selectstate')}}</option>
                                    <option value="北海道">北海道</option>
                                    <option value="青森県">青森県</option>
                                    <option value="岩手県">岩手県</option>
                                    <option value="宮城県">宮城県</option>
                                    <option value="秋田県">秋田県</option>
                                    <option value="山形県">山形県</option>
                                    <option value="福島県">福島県</option>
                                    <option value="茨城県">茨城県</option>
                                    <option value="栃木県">栃木県</option>
                                    <option value="群馬県">群馬県</option>
                                    <option value="埼玉県">埼玉県</option>
                                    <option value="千葉県">千葉県</option>
                                    <option value="東京都">東京都</option>
                                    <option value="神奈川県">神奈川県</option>
                                    <option value="新潟県">新潟県</option>
                                    <option value="富山県">富山県</option>
                                    <option value="石川県">石川県</option>
                                    <option value="福井県">福井県</option>
                                    <option value="山梨県">山梨県</option>
                                    <option value="長野県">長野県</option>
                                    <option value="岐阜県">岐阜県</option>
                                    <option value="静岡県">静岡県</option>
                                    <option value="愛知県">愛知県</option>
                                    <option value="三重県">三重県</option>
                                    <option value="滋賀県">滋賀県</option>
                                    <option value="京都府">京都府</option>
                                    <option value="大阪府">大阪府</option>
                                    <option value="兵庫県">兵庫県</option>
                                    <option value="奈良県">奈良県</option>
                                    <option value="和歌山県">和歌山県</option>
                                    <option value="鳥取県">鳥取県</option>
                                    <option value="島根県">島根県</option>
                                    <option value="岡山県">岡山県</option>
                                    <option value="広島県">広島県</option>
                                    <option value="山口県">山口県</option>
                                    <option value="徳島県">徳島県</option>
                                    <option value="香川県">香川県</option>
                                    <option value="愛媛県">愛媛県</option>
                                    <option value="高知県">高知県</option>
                                    <option value="福岡県">福岡県</option>
                                    <option value="佐賀県">佐賀県</option>
                                    <option value="長崎県">長崎県</option>
                                    <option value="熊本県">熊本県</option>
                                    <option value="大分県">大分県</option>
                                    <option value="宮崎県">宮崎県</option>
                                    <option value="鹿児島県">鹿児島県</option>
                                    <option value="沖縄県">沖縄県</option>
                                </select>
                            </div>
                        </div>
                        <!--Australia-->
                        <div class="form-group form-group-combined clearfix" v-if="Cart.CountryId==8">
                            <div class="form-group">
                                <label for="Order_State" class="sr-only">{{getInterfaceText('shop_selectstate')}}</label>
                                <select aria-describedby="stateRequired" id="Order_State" class="form-control form-control-floating-label-style" v-model="Order.State" required>
                                    <option value="">{{getInterfaceText('shop_selectstate')}}</option>
                                    <option value="NSW">New South Wales</option>
                                    <option value="QLD">Queensland</option>
                                    <option value="SA">South Australia</option>
                                    <option value="TAS">Tasmania</option>
                                    <option value="VIC">Victoria</option>
                                    <option value="WA">Western Australia</option>
                                    <option value="ACT">Australian Capital Territory</option>
                                    <option value="NT">Northern Territory</option>
                                </select>
                            </div>
                        </div>
                        <!-- Phone number -->
                        <div class="form-group clearfix">
                            <div class="wrapper-floating-label" :class="Order.Phone != null && Order.Phone != '' ? 'movelabelonload' : ''">
                                <label for="Order_Phone">{{getInterfaceText('form_phonenumber')}}</label>
                                <b-form-input style="height:auto;" aria-describedby="phoneRequired ErrorContactInfo" id="Order_Phone" type="tel" v-model="Order.Phone" required></b-form-input>
                            </div>
                        </div>
                        <!--Taiwan-->
                        <div v-if="Cart.CountryId==18">
                            <div class="form-group form-group-combined clearfix">
                                <b-form-input style="height:auto;" class="form-control text-box" id="OrderInvoiceType" placeholder="{{getInterfaceText('form_InvoiceType')}}" type="text" v-model="Order.InvoiceType"></b-form-input>
                            </div>
                            <div class="form-group form-group-combined form-group-combined-first-smaller clearfix">
                                <b-form-input style="height:auto;" class="form-control text-box" id="OrderVATNum" placeholder="{{getInterfaceText('form_vat_number')}}" type="text" v-model="Order.VATNum"></b-form-input>
                                <b-form-input style="height:auto;" class="form-control text-box" id="OrderVATName" placeholder="{{getInterfaceText('form_vat_name')}}" type="text" v-model="Order.VATName"></b-form-input>
                            </div>
                        </div>
                        <div v-show="Order.AxaptaConsumerAccountNumber == null || Order.AxaptaConsumerAccountNumber.length == 0">
                            <p style="margin:0;">
                                {{getInterfaceText('shop_savedetailsbyreateaccount')}}&nbsp;{{getInterfaceText('shop_enteringpassword')}}
                            </p>
                            <div id="passwordContainer">
                                <div class="form-group">
                                    <div class="wrapper-floating-label">
                                        <label for="OrderPassword">{{getInterfaceText('shop_Password')}}</label>
                                        <b-form-input type="password" id="OrderPassword" autocomplete="new-password" style="height:auto;max-width:300px" v-model="Order.Password"></b-form-input>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="wrapper-floating-label">
                                        <label for="OrderPasswordConfirmed">{{getInterfaceText('shop_ConfirmPassword')}}</label>
                                        <b-form-input type="password" id="OrderPasswordConfirmed" autocomplete="new-password" style="height:auto;max-width:300px" v-model="Order.PasswordConfirmed"></b-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="ErrorContactInfo" role="alert" class="alert alert-danger" v-show="errorContactInfo.length > 0" v-html="errorContactInfo" />
                        <div id="UserExistsError" role="alert" class="alert alert-danger" v-show="userExists == true" v-html="getInterfaceText('giantid_user_already_exists2')"></div>
                        <div class="submitbutton">
                            <button type="submit" class="btn btn-proceed" id="btnSubmitContactInfo" :class="proceedContactInfoButtonClicked == true && errorContactInfo.length == 0 ? 'btn-run-progress' : ''" :disabled="proceedContactInfoButtonClicked == true && errorContactInfo.length == 0" style="">{{getInterfaceText('shop_proceed')}} <i class="glyphicon glyphicon-menu-right" aria-hidden="true"></i></button>
                        </div>
                    </b-form>
                </b-card>
            </div>
            <div v-if="Order.Guid != null && Order.Guid.length > 0">
                <h3>Contact information</h3>
                <span>{{Order.Firstname}}</span>&nbsp;<span>{{Order.Lastname}}</span><br />
                {{Order.Email}}<br />
                {{Order.Phone}}<br />
                <span>{{Order.Street}}</span>&nbsp;<span>{{Order.Address2}}</span><br />
                <span>{{Order.Postalcode}} {{Order.City}} {{Order.State}}</span><br />

                <span v-if="Order != undefined && Order.VATName != undefined && Order.VATName.length > 0">{{Order.VATName}}</span>
                <span v-if="Order != undefined && Order.VATNum != undefined && Order.VATNum.length > 0">{{Order.VATNum}}</span>
                <span v-if="Order != undefined && Order.VATExtra != undefined && Order.VATExtra.length > 0">{{Order.VATExtra}}</span>
            </div>
        </div>
        <div v-if="showLogin == true">
            <div class="form-group">
                <div class="wrapper-floating-label movelabelonload">
                    <label for="loginEmail">{{getInterfaceText('form_emailaddress')}}</label>
                    <input aria-describedby="LoginErrorDescription" id="loginEmail" name="Email" type="text" v-model="loginEmail">
                </div>
            </div>
            <div class="form-group" style="margin-bottom:5px;">
                <div class="wrapper-floating-label movelabelonload">
                    <label for="Password">{{getInterfaceText('shop_Password')}}</label>
                    <input aria-describedby="LoginErrorDescription" id="Password" name="Password" type="password" v-model="loginPassword">
                </div>
            </div>



            <!-- alert -->
            <div id="LoginErrorDescription" role="alert" class="alert alert-danger" v-show="errorLogin.length > 0" v-html="errorLogin"></div>
            <p class="passwordforgotten"><a :href="PasswordForgottenUrl" class="passwordforgotten">{{getInterfaceText('shop_password_forgotten')}}</a></p>
            <!-- button -->
            <button type="button" id="btnLogin" style="margin:10px 0 25px 0;" class="btn btn-proceed btn-with-icon-right" v-on:click="Login()" :class="proceedLoginButtonClicked == true && errorLogin.length == 0 ? 'btn-run-progress' : ''">
                {{
getInterfaceText('shop_LoginButton')
                }} <i class="icongiant-lock" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import vueStore from '../store/store.js';
    import cartMixin from '../mixins/cart-mixin.js';
    import generalMixin from '../mixins/general.js';
    import LoqateAddressSearch from './LoqateAddressSearch';
    import { ref } from 'vue'

    export default {
        name: 'contact',
        mixins: [cartMixin, generalMixin],
        components: {
            LoqateAddressSearch
        },
        props: [],
        template: '#contact',
        data: function () {
            return {
                validateAddressAtLoqate: window.validateAddressAtLoqate,
                showLogin: false,
                errorContactInfo: '',
                errorLogin: '',
                userExists: false,
                selectedText: ref('')
            }
        },
        methods: {
            SubmitContactForm(event) {
                event.preventDefault()
                this.errorContactInfo = '';
                this.proceedContactInfo();
            },
            checkHouseNumber() {
                if ((this.Cart.CountryId == 12 || this.Cart.CountryId == 16) && this.Order != null && this.Order.Street != null && this.Order.Street.length > 0) {
                    this.Order.Street = this.Order.Street.replace(/[.,]+/g, '');
                } else {
                    return true;
                }
            },
            validateAddress() {
                if ((this.Cart.CountryId == 12 || this.Cart.CountryId == 16) && this.Order != null && this.Order.Street != null && this.Order.Street.length > 0) {
                    return /\d/.test(this.Order.Street);
                } else {
                    return true;
                }
            },
            proceedContactInfo() {
                //check required fields
                this.proceedContactInfoButtonClicked = true;
                this.$emit('setLoadingFromChild', true);
                var that = this;
                if (window.validateAddressAtLoqate != undefined && window.validateAddressAtLoqate == true) {
                    this.validateLoqateAddress(this.Order.Street, this.Order.Postalcode, this.Order.City, this.Order.Email, this.Order.Phone, this.Order.State, this.Order.LoqateKey, true,
                        function () {
                            that.proceedContactInfoAfterValidation();
                        },
                        function (address) {
                            that.Order.Street = address.Line1;
                            that.Order.Postalcode = address.PostalCode;
                            that.Order.City = address.City;
                            that.Order.State = address.Province;
                        },
                        function (data) {
                            that.$emit('setLoadingFromChild', false);
                            that.proceedContactInfoButtonClicked = false;
                            if (data != undefined) {
                                if (data.PhoneToFormat != null && data.PhoneToFormat.length > 0) {
                                    that.Order.Phone = data.PhoneToFormat;
                                }
                            }
                        }
                    );
                } else {
                    that.proceedContactInfoAfterValidation();
                }

                //push email to klaviyo
                //if (that.getConsent().indexOf('statistics') > -1 && that.getConsent().indexOf('marketing') > -1) {
                //    var _learnq = _learnq || [];
                //    _learnq.push(['identify', { '$email': this.Order.Email }]);
                //}

                //track GA
                window.trackEventGlobalAndLocal('Create account', 'Click', 'Checkout');
            },
            proceedContactInfoAfterValidation() {
                this.$emit('setLoadingFromChild', true);
                this.proceedContactInfoButtonClicked = true;
                this.contactinfoHTML = '';
                var that = this;
                var search = this.Order.Street + ' ' + this.Order.Postalcode + ' ' + this.Order.City + ',' + this.Country;
                window.getLatLng(search, function (lat, lng) {
                    that.Order.Latitude = lat;
                    that.Order.Longitude = lng;

                    //submit form to collect contact info
                    var url = '/' + window.culture + '/shop/setcontactinfo';
                    axios({
                        method: "post",
                        url: url,
                        data: {
                            OrderFirstname: that.Order.Firstname,
                            OrderEmail: that.Order.Email,
                            OrderLastname: that.Order.Lastname,
                            OrderStreet: that.Order.Street,
                            OrderAddress2: that.Order.Address2,
                            OrderCity: that.Order.City,
                            OrderPostalcode: that.Order.Postalcode,
                            OrderState: that.Order.State,
                            OrderVATName: that.Order.VATName,
                            OrderVATNum: that.Order.VATNum,
                            OrderVATExtra: that.Order.VATExtra,
                            OrderClientType: that.Order.ClientType,
                            OrderLoqateKey: that.Order.LoqateKey,
                            OrderLatitude: that.Order.Latitude,
                            OrderLongitude: that.Order.Longitude,
                            OrderGAclientId: that.GAclientId(),
                            OrderInvoiceType: that.Order.InvoiceType,
                            OrderPhone: that.Order.Phone
                        },
                    })
                        .then(function (res) {
                            that.isValidContactInfo = res.data.result;
                            that.isValidShippingOption = false;
                            that.isValidSelectedDealer = false;
                            /*that.isValidGiftcardOrCoupon = false;*/
                            that.isValidPayment = false;
                            that.isValidSummary = false;
                            if (res.data.result == true) {
                                that.axaptaConsumerAccountNumber = res.data.axaptaConsumerAccountNumber;
                                that.getCartSummary(true, function () {
                                    //if (that.Cart.ContainsOnlyGiftcard == true) {
                                    //    //$('#collapsePayment').collapse('show');
                                    //} else {
                                    //    //$('#collapseShippingOptions').collapse('show');
                                    //}
                                    that.$emit('setLoadingFromChild', false);
                                    that.proceedContactInfoButtonClicked = false;
                                }, 'SetContactInfo'); //especially for gear items. Tax will change.
                                if (that.getConsent().indexOf('marketing') > -1) {
                                    //try {
                                    //    window["AnalyticsBuilder"].create(window.inTestMode ? { debug: true } : {})
                                    //        .asCheckoutStep({
                                    //            step: 1,
                                    //            option: that.axaptaConsumerAccountNumber === '' ? 'NotLoggedIn' : 'LoggedIn',
                                    //            checkout_step: 1,
                                    //            checkout_option: that.axaptaConsumerAccountNumber === '' ? 'NotLoggedIn' : 'LoggedIn',
                                    //            items: that.GetGACartItems()
                                    //        }).send();
                                    //} catch (e) {
                                    //    //speciaal voor Brave browser die er uit klapt.
                                    //    console.log(e);
                                    //}
                                }
                            } else {
                                that.proceedContactInfoButtonClicked = false;
                                that.$emit('setLoadingFromChild', false);
                                if (res.data.userExists != undefined && res.data.userExists == true) {
                                    that.userExists = true;
                                } else {
                                    // Find zipcode field
                                    var zipCodeField = document.getElementById('OrderPostalcode');
                                    zipCodeField.focus();
                                    that.errorContactInfo = res.data.error;
                                }
                            }
                        });
                });
            },
            Login() {
                this.$emit('setLoadingFromChild', true);
                this.errorLogin = '';
                this.userExists = false;
                var that = this;
                this.accountLogin(this.loginEmail, this.loginPassword, true, function (data) {
                    that.Order.Firstname = data.Details.OrderFirstname;
                    that.Order.Lastname = data.Details.OrderLastname;
                    that.Order.Street = data.Details.OrderStreet;
                    that.Order.Address2 = data.Details.OrderAddress2;
                    that.Order.Postalcode = data.Details.OrderPostalcode;
                    that.Order.City = data.Details.OrderCity;
                    that.Order.State = data.Details.OrderState;
                    that.Order.Phone = data.Details.OrderPhone;
                    that.Order.Email = data.Details.OrderEmail;
                    that.Order.AxaptaConsumerAccountNumber = data.Details.OrderAxaptaConsumerAccountNumber;
                    that.Order.AddToNewsletter = data.Details.OrderAddToNewsletter;
                    that.Order.Guid = null;
                    that.showLogin = false;
                    that.$emit('setLoadingFromChild', false);
                }, function (data) {
                    that.$emit('setLoadingFromChild', false);
                    if (data.error != undefined) {
                        that.errorLogin = data.error;
                    }
                });
            },
            Edit() {
                this.Order.Guid = null;
                this.showLogin = false;
                //window.pca.load();
            }
        },
        computed: {
            Order: {
                get() {
                    if (vueStore.state && vueStore.state.cart && vueStore.state.cart.Order) {
                        return vueStore.state.cart.Order;
                    } else {
                        return {};
                    }
                }
            },
            PasswordForgottenUrl: {
                get() {
                    return '/' + window.culture + '/account/resetpasswordrequest';
                }
            }
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-checkout').dataset.interfacetexts);
        },
        mounted() {
            window.vueContact = this;

            //default validation message to all form fields
            var elements = document.forms['contactform'].elements;
            for (var i = 0; i < elements.length; i++) {
                elements[i].setAttribute('oninvalid', 'this.setCustomValidity(\'' + this.getInterfaceText('form_thisfielisrequired') + '\')');
                elements[i].setAttribute('oninput', 'setCustomValidity(\'\')');
            }
        }
    }
</script>
